import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import cx from 'classnames';
import tooltipCss from 'Styles/tooltip';

const Dot = styled.div`
  width: ${props => props.diameter}px;
  height: ${props => props.diameter}px;
  min-width: 14px;
  position: relative;
  border-radius: 20px;
  background-color: ${(props) => {
    let colour;
    switch (props.status) {
      case 'qa':
        colour = '#f8d053';
        break;
      case 'rej':
        colour = '#f55753';
        break;
      case 'pub':
        colour = '#10cfbd';
        break;
      case 'dev':
      default:
        colour = 'lightgrey';
        break;
    }
    return colour;
  }};
`;

const AdStatusDot = ({ status, diameter = 14, classes = '' }) =>

  <Dot
    className={cx(classes, tooltipCss.base, tooltipCss.bottom)}
    data-original-title={status}
    diameter={diameter}
    status={status}
  />;

AdStatusDot.propTypes = {
  status: PropTypes.string,
  diameter: PropTypes.number,
  classes: PropTypes.string,
};

export default AdStatusDot;



// WEBPACK FOOTER //
// ./app/javascript/packs/App/Builder/components/BuilderTitle/AdStatusDot.jsx